import React from "react";
import Box from "../../Box";
import "./styles.css";

type TProps = {
    children: React.ReactNode;
}

const TutorialContent = ({children}: TProps) => {
    return <Box>
        {children}
    </Box>;
}

export default React.memo(TutorialContent);
